import httpService from "./httpService";
import utils from "./utils";

export default {

  findAll(example, pageable) {
    pageable = utils.initPageableParams(pageable);
    let params = utils.merge(example, pageable);
    return httpService.get("actionLog", {params: params});
  },

  findAllByVbIncomingDoc(id, subDocId, pageable) {
    pageable = utils.initPageableParams(pageable);
    let params = utils.merge({objectId: id, subDocId: subDocId}, pageable);
    return httpService.get("actionLog/findAllByVbIncomingDoc", {params: params});
  },

  findAllAccessible(id, pageable) {
    pageable = utils.initPageableParams(pageable)
    let params = utils.merge({vbIncomingProcessId: id}, pageable);
    return httpService.get("actionLog/findAllAccessible", {params: params});
  },

  findAllByVbOutgoingDoc(id, pageable) {
    pageable = utils.initPageableParams(pageable)
    let params = utils.merge({objectId: id}, pageable);
    return httpService.get("actionLog/findAllByVbOutgoingDoc", {params: params});
  },

  findAllForHcCaseCommands(hcCaseCommandsId, hcCaseCommandsCommonId) {
    let params = {hcCaseCommandsId: hcCaseCommandsId, hcCaseCommandsCommonId: hcCaseCommandsCommonId};
    return httpService.get("actionLog/findAllForHcCaseCommands", {params: params});
  }
}



// WEBPACK FOOTER //
// ./src/services/actionLogService.js